import { ADDRESS_SHIPPING_TYPE, ADDRESS_BOTH_TYPE } from 'utils/constants';

// Generates a display for the dropdown based on the address
export const getAddressDisplay = (address) => {
  const fieldsToShow = ['city', 'state', 'zipcode'];

  return fieldsToShow.reduce((displayText, fieldName) => {
    const value = address[fieldName];

    return value ? `${displayText}, ${value}` : displayText;
  }, address.address1);
};

// Parses addresses into dropdown options
export const getFavoriteAddressesOptions = (addresses) => {
  return addresses.map((addressResult) => {
    const { addressId, address } = addressResult;

    return { id: addressId, text: getAddressDisplay(address) };
  });
};

// Filter valid favorite addresses from results
export const getFavoriteAddresses = (addresses) => {
  return addresses.filter((address) => {
    const { favorite, type } = address;

    return (
      favorite && (type === ADDRESS_SHIPPING_TYPE || type === ADDRESS_BOTH_TYPE)
    );
  });
};
